const ACTIVATION_RETURN_KEY = 'inktap:activation-return:v1';
const ACTIVATION_PATH_PATTERN = /^\/activate\?card=[A-Za-z0-9_-]{32}$/;

export const activationPathForCard = (cardPublicId: string) =>
  `/activate?card=${encodeURIComponent(cardPublicId)}`;

export const rememberActivationReturn = (cardPublicId: string) => {
  if (!/^[A-Za-z0-9_-]{32}$/.test(cardPublicId)) return;
  window.localStorage.setItem(ACTIVATION_RETURN_KEY, activationPathForCard(cardPublicId));
};

export const consumeActivationReturn = () => {
  const candidate = window.localStorage.getItem(ACTIVATION_RETURN_KEY);
  window.localStorage.removeItem(ACTIVATION_RETURN_KEY);
  return candidate && ACTIVATION_PATH_PATTERN.test(candidate) ? candidate : null;
};
